import {
  AttributeKindEnum,
  TemplateAttributeRole,
  type HarvestOperationTemplateAttribute,
} from "@brewbase/db/types";
import type { BaseTemplateAttribute } from "@/features/template-block-editor/types";

/** Right-hand flags cell of a scalar row (operation editor). */
export function renderOperationRowFlags(attr: BaseTemplateAttribute) {
  const attribute = attr as HarvestOperationTemplateAttribute;
  return (
    <>
      {attribute.code && (
        <span
          className="text-xs font-mono text-olive-9 truncate max-w-[80px]"
          title={attribute.code}
        >
          {attribute.code}
        </span>
      )}
      {attribute.role === TemplateAttributeRole.PARAMETER && (
        <DefaultValueDisplay attribute={attribute} />
      )}
      {attribute.is_control_point && (
        <span className="border border-border px-1 py-0.5 text-xs font-sans">
          CP
        </span>
      )}
    </>
  );
}

/** Tabular block header badge (operation editor). */
export function renderOperationTabularBadge(attr: BaseTemplateAttribute) {
  const attribute = attr as HarvestOperationTemplateAttribute;
  if (!attribute.is_control_point) return null;
  return <span className="border border-border px-1 py-0.5 text-xs">CP</span>;
}

function DefaultValueDisplay({
  attribute,
}: {
  attribute: HarvestOperationTemplateAttribute;
}) {
  if (
    attribute.kind === AttributeKindEnum.SINGLE_NUMBER &&
    attribute.default_value_number != null
  ) {
    return (
      <span className="truncate tabular-nums">
        {String(attribute.default_value_number)}
        {attribute.default_value_measurement_unit &&
        attribute.default_value_measurement_unit !== "1"
          ? ` ${attribute.default_value_measurement_unit}`
          : ""}
      </span>
    );
  }

  if (
    attribute.kind === AttributeKindEnum.CHECK &&
    attribute.default_check_value != null
  ) {
    return (
      <span className="font-sans text-xs">
        {attribute.default_check_value ? "✓" : "—"}
      </span>
    );
  }

  if (attribute.kind === AttributeKindEnum.COMPUTED_NUMBER) {
    return <span className="font-sans text-xs italic">computed</span>;
  }

  return <span className="font-sans text-xs text-muted-foreground/50">—</span>;
}
